import React from 'react';
import styled from 'styled-components';

import LiveCountdownContainer from '../live-countdown/LiveCountdownContainer';
import LiveChatContainer from './live-chat';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;

  @media (max-width: 768px) and (orientation: portrait) {
    flex-direction: column;
    height: unset;
  }

  @media screen and (orientation: landscape) and (max-width: 1024px) {
    height: 90%;
  }
`;

const Video = styled.iframe`
  height: 100%;
  width: 100%;
  margin-right: 0.5rem;

  @media (max-width: 768px) {
    height: auto;
    margin-bottom: 2rem;
    margin-right: 0;
  }

  @media screen and (orientation: landscape) and (max-width: 1024px) {
    margin-right: 0;
  }
`;

interface LivestreamProps {
  url: URL;
  chatUrl?: URL;
  secondsUntilLive?: number;
  showFullscreenChat?: boolean;
}

const Livestream: React.FC<LivestreamProps> = ({
  url,
  chatUrl,
  secondsUntilLive,
  showFullscreenChat,
}) => {
  const hideLandscapeChat = window.matchMedia(
    'screen and (orientation: landscape) and (max-width: 1024px)',
  ).matches;

  if (url) {
    return (
      <Container id="livestream-player">
        {chatUrl ? (
          <>
            {secondsUntilLive <= 0 ? (
              <Video
                className="live-iframe"
                src={url.href}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : (
              <LiveCountdownContainer secondsUntilLive={secondsUntilLive} />
            )}

            <LiveChatContainer
              showChat={
                (!hideLandscapeChat && secondsUntilLive <= 0) ||
                (hideLandscapeChat && showFullscreenChat)
              }
              chatUrl={chatUrl}
            />
          </>
        ) : (
          <Video
            title="livestream player"
            src={url.href}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            role="application"
          />
        )}
      </Container>
    );
  }
};

export default Livestream;
